import { useContext } from "react";
import ReminderContext from "./ReminderContext.jsx";

/**
 * Reads the shared reminder poller from the nearest <ReminderProvider>.
 *
 * Lives outside ReminderContext.jsx so that module only exports components —
 * mixing a hook into it defeats React Fast Refresh for every screen that
 * imports it.
 */
export default function useReminders() {
  return useContext(ReminderContext);
}
